import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/vrart_profile.jpg'
import _imports_1 from '@/assets/img/vrart_profile@2x.jpg'
import _imports_2 from '@/assets/img/learn_hiroshima.png'
import _imports_3 from '@/assets/img/presenter_hippy.jpg'
import _imports_4 from '@/assets/img/presenter_hippy@2x.jpg'
import _imports_5 from '@/assets/img/presenter_naito.jpg'
import _imports_6 from '@/assets/img/presenter_naito@2x.jpg'
import _imports_7 from '@/assets/img/learn_nagasaki.png'
import _imports_8 from '@/assets/img/presenter_shirabe.jpg'
import _imports_9 from '@/assets/img/presenter_shirabe@2x.jpg'
import _imports_10 from '@/assets/img/presenter_watanabe.jpg'
import _imports_11 from '@/assets/img/presenter_watanabe@2x.jpg'


const _withScopeId = n => (_pushScopeId("data-v-083d515c"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = _imports_4 + ' 2x'
const _hoisted_3 = _imports_6 + ' 2x'
const _hoisted_4 = _imports_9 + ' 2x'
const _hoisted_5 = _imports_11 + ' 2x'
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thanks" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "thanks-en" }, "SPECIAL THANKS"),
  /*#__PURE__*/_createElementVNode("p", { class: "thanks-ja" }, "プレゼンターの皆さん")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vrart" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "person reverse" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "person-text",
        style: {"margin-right":"5%"}
      }, [
        /*#__PURE__*/_createElementVNode("p", { class: "person-text_name" }, "せきぐち あいみ"),
        /*#__PURE__*/_createElementVNode("div", { class: "person-text_line" }),
        /*#__PURE__*/_createElementVNode("p", { class: "person-text_job" }, "VR ARTIST"),
        /*#__PURE__*/_createElementVNode("p", { class: "person-text_detail" }, " 本イベントでは、学生たちに対するパフォーマンスの披露及びVR制作のノウハウを伝授。VR空間に3Dのアートを描く、VRアーティストとして活動中。アート制作やライブペインティングのステージ公演を国内や海外（アメリカ、ドイツ、フランス、ロシア、UAE、シンガポール、タイ、マレーシアなど）でも行っている。昨年3月には1300万円にて作品が落札。第一人者として、VRアートの可能性を広げている。 "),
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.creativevillage.ne.jp/lp/aimi_sekiguchi/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, " OFFICIAL WEB ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "person-img" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          srcset: _hoisted_1,
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("div", { class: "round mc" }, "GUEST")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "speaker" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "speaker-hiroshima" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("h3", null, "HIROSHIMA side"),
    /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "person" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "person-img" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_3,
            srcset: _hoisted_2,
            alt: ""
          }),
          /*#__PURE__*/_createElementVNode("div", { class: "round" }, "MC")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "person-text" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_name" }, "HIPPY"),
          /*#__PURE__*/_createElementVNode("div", { class: "person-text_line" }),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_job" }, "SINGER SONG WRITER"),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_detail" }, " 広島市出身のシンガーソングライター。YouTube、MC、ラジオ、ナレーション、舞台等で活躍中。地元広島の被爆伝承事業に取組み「原爆の語り部 被爆体験者の証言の会」を毎月6日に広島の繁華街のBarで開催している。（※現在はオンラインにて開催中） ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "person" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "person-img" }, [
          /*#__PURE__*/_createElementVNode("img", {
            class: "nagasaki",
            src: _imports_5,
            srcset: _hoisted_3,
            alt: ""
          }),
          /*#__PURE__*/_createElementVNode("div", { class: "round" }, "SPEAKER")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "person-text" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_name" }, "内藤 達郎"),
          /*#__PURE__*/_createElementVNode("div", { class: "person-text_line" }),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_job" }, "平和学習講師"),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_detail" }, " 1941年生まれ。3歳の時に被爆。中学校卒業後は歯科技工士としてキャリアを積み、1988年広島県歯科技工士会会長を務めた。現在は平和公園にてガイドを務める傍ら、講演や広島市最大級の被爆建物「旧陸軍被服支廠（ししょう）」の保存運動などを通して平和活動に取組んでいる。「広島と福島を結ぶ会」副代表。今回は「広島の復興と街並みに込められた想い」というテーマでお話しいただいた。 ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "speaker" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "speaker-nagasaki" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_7,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("h3", null, "NAGASAKI side"),
    /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "person" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "person-img" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_8,
            srcset: _hoisted_4,
            alt: ""
          }),
          /*#__PURE__*/_createElementVNode("div", { class: "round" }, "SPEAKER")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "person-text" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_name" }, "調 仁美"),
          /*#__PURE__*/_createElementVNode("div", { class: "person-text_line" }),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_job" }, "平和学習講師"),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_detail" }, " 1962年長崎市生まれ。祖父母、父母が被爆者。2008年、原爆や戦争の知識普及を目指し平和学習グループ「ピースバトン・ナガサキ」を設立。被爆交流証言者として県内外で活動中。今回は、長崎の平和に関するモニュメントの形に込められた想いなどをお話しいただいた。 ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "person" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "person-img" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_10,
            srcset: _hoisted_5,
            alt: ""
          }),
          /*#__PURE__*/_createElementVNode("div", { class: "round" }, "MC")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "person-text" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_name" }, "渡辺 真美"),
          /*#__PURE__*/_createElementVNode("div", { class: "person-text_line" }),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_job" }, "FREE ANNOUNCER"),
          /*#__PURE__*/_createElementVNode("p", { class: "person-text_detail" }, " 久留米市出身。アナウンサーとしてテレビ佐世保に入社。ナレーション制作事務所でのCMやTV番組出演を経て、現在は佐世保市を中心にMC・リポーター・ナレーションなど幅広く活躍中。 ")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, _hoisted_8))
}